/**
 * @desc 手机验证码登录
 */
import { LoginResult, LoginSmsForm } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type LoginMemberBySmsParameter = LoginSmsForm

const method = 'POST'
const url = '/auth/member/login/sms'

export const loginMemberBySmsApi = (
  data?: LoginMemberBySmsParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<LoginResult>({
    method,
    url,
    data,
    ...config
  })
}

loginMemberBySmsApi.method = method
loginMemberBySmsApi.url = url
